import axios from "axios";
import {getSelfToken} from '../../_helpers/auth/secureToken'
import {playistEndpoint} from '../_constants/api.constant'
export async function updatePlaylist(playlistId,dataObj) {
    const response = await axios.put(
        playistEndpoint.UPDATE_PLAYLIST,
        dataObj,
        {   params:{id:playlistId},
            headers: {
                'Authorization': 'Token ' + getSelfToken(),
            },
        }
    ).then(function (response) {
        return response;
    }).catch(function (error) {
        return error.response;
    });
    return response
}